export default __webpack_public_path__ + "static/media/ILPlatform_Banner.47d6450c.png";